// let getUrlObject = (urls, instancename, urlname, action) => {
//   return urls[instancename]
//     .find(x => x.name === urlname).methods
//     .find(x => x.action === action)
// };

const state = {
  permission: {},
};

const mutations = {
  appendPermission(state, urls){
    state.permission =  (urls);
  },
  clearPermission(state){
    state.permission = {};
  }
};


const getters = {
  checkAlreadyLoaded: (state) =>  {
    if (Object.keys(state.permission).length == 0)
      return false;
    else
      return true;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
}
